<!-- The transaction the panel is about, as the head of the panel: the bank's line, its amount
     signed as the ledger shows it, and where and when it happened. -->
<div class="banktransdetail" *ngIf="activities?.length && activities[curIdx] as txn">
  <div class="section-label">Bank transaction</div>
  <div class="statement-head">
    <div class="statement-head__title" [title]="txn.description">{{ txn.description }}</div>
    <div class="statement-head__amount">
      <span *ngIf="txn.amount > 0">+{{ txn.amount | number:'1.2-2' }}</span>
      <span *ngIf="txn.amount < 0">-{{ txn.amount * -1 | number:'1.2-2' }}</span>
      <span *ngIf="txn.amount == 0">0.00</span>
    </div>
  </div>
  <div class="statement-head__meta">
    <span>{{ txn.transactionDate | formatedDate }}</span>
    <span *ngIf="txn.accountName"> · {{ txn.accountName }}</span>
  </div>
  <div class="statement-head__chips">
    <!-- The ledger's own status chip, so the panel and the row it came from agree. -->
    <span class="statement-chip" [class.statement-chip--done]="isReconciled(txn)">
      {{ isReconciled(txn) ? 'Reconciled' : 'To reconcile' }}
    </span>
    <!-- Where it is in a report's workflow. Only inside a report, where that is the question. -->
    <span class="statement-chip statement-chip--quiet" *ngIf="txn.assignmentStatus">
      {{ txn.assignmentStatus }}
    </span>
  </div>
</div>
